<template>
  <b-modal
    id="trasladarAvls"
    ref="modal"
    title="TRASLADO DE AVL'S"
    size="lg"
    hide-footer
    lazy
    centered
    @show="onShown"
  >
    <CargarAvlsPorTextoModal
      @update="updateAvlsSeleccionados"
      :availableAvls="availableAvlIds"
      :selectedAvls="selectedAvlIds"
      ref="cargarAvlsPorTextoModal"
    ></CargarAvlsPorTextoModal>
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <div class="card">
                <div class="card-body">
                  <div class="col-12 form-group form-group-sm">
                    <label for="id_avls" class="label">AVL'S</label>
                    <input
                      class="form-control bg-white text-center"
                      style="cursor: text"
                      type="text"
                      id="id_avls"
                      name="id_avls"
                      v-model="id_avls"
                      disabled
                    />
                  </div>
                  <div class="col-12 d-flex justify-content-between">
                    <button
                      type="button"
                      @click="borrar"
                      class="btn btn-danger"
                    >
                      Borrar todo
                    </button>
                    <button
                      type="button"
                      @click="agregarIdsAvls"
                      class="btn btn-success"
                    >
                      Agregar avls por texto
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="instalador">Instalador de origen</label>
              <SelectInstalador v-model="instaladorOrigen" />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="instalador"
                >Instalador de destino</label
              >

              <SelectInstalador v-model="instaladorDestino" />
            </div>
            <div class="col-12 form-group form-group-sm">
              <label for="fechaMovimiento" class="label"
                >Fecha de movimiento</label
              >
              <input
                class="form-control bg-white text-center"
                type="date"
                id="fechaMovimiento"
                name="fechaMovimiento"
                v-model="fechaMovimiento"
              />
            </div>
            <div class="col-12 form-group form-group-sm">
              <label for="comentario" class="label">Comentario</label>
              <textarea
                class="form-control bg-white text-center"
                type="text"
                id="comentario"
                name="comentario"
                v-model="comentario"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 d-flex justify-content-between">
              <button type="button" @click="cancelar" class="btn btn-danger">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">Confirmar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
<script>
import moment from "moment";
import axios from "axios";
import SelectInstalador from "../../Clientes/Contratos/Commons/SelectInstalador.vue";
import CargarAvlsPorTextoModal from "./CargarAvlsPorTextoModal.vue";
export default {
  name: "modificar-registro-de-avls",
  props: ["idAvls", "rowData", "seleccionados"],
  data: () => ({
    comentario: "",
    instaladorOrigen: null,
    instaladorDestino: null,
    id_avls: "",
    fechaMovimiento: null,
  }),
  components: { SelectInstalador, CargarAvlsPorTextoModal },
  computed: {
    FechaMovimiento: {
      get() {
        return moment().format("YYYY-MM-DD");
      },
    },
    availableAvlIds() {
      if (!this.rowData || !Array.isArray(this.rowData)) return [];
      return this.rowData.map((avl) => avl.id_avl.toString());
    },
    selectedAvlIds() {
      return this.seleccionados.map((avl) => avl.id_avl.toString());
    },
  },
  methods: {
    onShown() {
      this.comentario = "";
      this.instaladorOrigen = null;
      this.instaladorDestino = null;
      this.id_avls = this.idAvls;
      this.fechaMovimiento = this.FechaMovimiento;
    },
    agregarIdsAvls() {
      this.$bvModal.show("cargarAvlsPorTextoModal");
    },
    borrar() {
      this.id_avls = "";
      this.$emit("updateSelection", this.seleccionados);
    },
    cancelar() {
      this.borrar();
      this.$bvModal.hide("trasladarAvls");
    },
    async updateAvlsSeleccionados(avlsIngresadosString) {
      if (!avlsIngresadosString || !avlsIngresadosString.trim()) {
        await this.$msgBoxOk("No se ingresaron AVL's válidos");
        return;
      }
      const avlsNuevos = avlsIngresadosString
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      const avlsExistentesEnCampo = this.id_avls
        ? this.id_avls
            .split(",")
            .map((id) => id.trim())
            .filter((id) => id !== "")
        : [];

      const avlsYaExistentes = avlsNuevos.filter((id) =>
        avlsExistentesEnCampo.includes(id),
      );

      if (avlsYaExistentes.length > 0) {
        await this.$msgBoxOk(
          `Los siguientes AVL's ya están agregados:\n${avlsYaExistentes.join(", ")} ; solo se cargarán los nuevos AVL's.`,
        );
      }

      const avlsExistentesEnTabla = avlsNuevos.filter((id) =>
        this.availableAvlIds.includes(id),
      );

      const avlsNoEncontrados = avlsNuevos.filter(
        (id) => !this.availableAvlIds.includes(id),
      );

      const todosLosAvls = [
        ...new Set([...avlsExistentesEnCampo, ...avlsExistentesEnTabla]),
      ];

      this.id_avls = todosLosAvls.join(", ");

      let mensajeResumen = "";
      if (avlsExistentesEnTabla.length > 0) {
        mensajeResumen = `Se agregaron ${avlsExistentesEnTabla.length} AVL's válidos.`;
      }

      if (avlsNoEncontrados.length > 0) {
        if (mensajeResumen) mensajeResumen += "\n\n";
        mensajeResumen += `Los siguientes AVL's no se encontraron en la lista actual:\n${avlsNoEncontrados.join(", ")}`;
      }

      if (!mensajeResumen) {
        mensajeResumen = "No se agregaron nuevos AVL's.";
      }
      if (avlsExistentesEnTabla.length > 0 && avlsYaExistentes.length > 0)
        return;

      await this.$msgBoxOk(mensajeResumen);
    },
    async submit() {
      if (!this.instaladorOrigen) {
        this.$msgBoxOk("Por favor , elija un instalador de origen");
        return;
      }
      if (!this.instaladorDestino) {
        this.$msgBoxOk("Por favor , elija un instalador de destino");
        return;
      }
      if (!this.fechaMovimiento) {
        this.$msgBoxOk("Por favor , seleccione una fecha");
        return;
      }
      if (!this.id_avls || !this.id_avls.trim()) {
        this.$msgBoxOk("Por favor , ingrese al menos un ID de AVL");
        return;
      }
      const resp = await axios.post("/execute", {
        method: "CLI.TrasladoDeAvls",
        parameters: [
          {
            name: "id_instalador_origen",
            value: this.instaladorOrigen.id_instaladores,
          },
          {
            name: "id_instalador_destino",
            value: this.instaladorDestino.id_instaladores,
          },
          { name: "comentario", value: this.comentario },
          { name: "id_avls", value: this.id_avls },
          { name: "fecha_movimiento", value: this.fechaMovimiento },
        ],
      });
      if (resp.data.ok) {
        this.$msgBoxOk("Exito!").then(() => this.$emit("update"));
        this.$bvModal.hide("trasladarAvls");
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
  },
  watch: {},
};
</script>
